import { render, staticRenderFns } from "./CardInstallments.vue?vue&type=template&id=dfdaba36&scoped=true"
import script from "./CardInstallments.vue?vue&type=script&lang=js"
export * from "./CardInstallments.vue?vue&type=script&lang=js"
import style0 from "./CardInstallments.vue?vue&type=style&index=0&id=dfdaba36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdaba36",
  null
  
)

export default component.exports